import { FieldSchemaUnits } from 'app/shared/collections/StatDefinition';
import { Operator } from 'app/shared/operators';
import { IMSValueGetter, StatFilterFnGenerator } from '../../value_getters/value_getter';

export class GenericIPDeviceStatValueGetter extends IMSValueGetter {
    constructor(
        statCollection,
        statKey,
        units: FieldSchemaUnits,
        operators: Operator[],
        filterFunctionGenerator: StatFilterFnGenerator = null,
    ) {
        super(statCollection, statKey, units, filterFunctionGenerator, [], operators);
    }

    getValueForStat(stat) {
        if (!stat) {
            return undefined;
        }

        if (stat.resource) {
            return stat.resource[this.statKey];
        }

        return stat[this.statKey];
    }
}
